import {getDetails, userRights, bulkUpdate, uploadImage, getImageUploadURL, validateScreenName, createScreenName} from '@/libs/api/api'
import {message, loader, getImageUrl, onError, copyText, navigateTo, copyElement, urlValidation, errorHandler, logout} from '@/libs/helper'
import {cloneDeep, isEmpty, uniqBy, sortBy} from 'lodash'
import constants from '@/libs/constant/constants'
import articlesTableMixin from '@/mixins/articlesTableMixin'

export default {
    name: 'PublisherForm',
    mixins: [articlesTableMixin],
    props: {},
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', false)
        this.$store.dispatch('setContainer', true)
    },
    mounted() {
        this.getMetaList('PUBLISHER')
        this.getUserRights()
    },
    components: {
        SocialMediaForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SocialMediaForm/SocialMediaForm.vue'), 
        SearchDropdown: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SearchDropdown/SearchDropdown.vue'), 
        RegisteredList: () => import(/* webpackChunkName: "group-admin" */'@/components/component/RegisteredList/RegisteredList.vue'), 
        AdminSearch: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AdminSearch/AdminSearch.vue'), 
        ImageUpload: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/ImageUpload/ImageUpload.vue'),
        LocationForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/LocationForm/LocationForm.vue'),
        ReplaceMeta: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/ReplaceMeta/ReplaceMeta.vue'),
        Table: () => import(/* webpackChunkName: "group-admin" */'@/components/component/Reuse/Table/Table.vue'),
    },

    watch: {
        activeTab (value) {
            if (value === constants.PUBLISHER_TABS.ARTICLES) {
                this.changePage(1)
            }
        }
    },
    data() {
        return {
            category: 'PUBLISHER',
            des: {},
            address: {},
            publisher: {},
            formData: {},
            contentData: {},
            metaToAdd: {},
            url: '',
            shortUrl: '',
            cleanInput: false,
            getUserData: {},
            socialMedia: {},
            isEmpty,
            getImageUrl,
            imagePreview: '',
            publications: [],
            contactDetail: {},
            copyText,
            navigateTo,
            constants,
            activeTab: constants.PUBLISHER_TABS.CONTENT_DB,
            onError,
            publisherImage: {},
            isReplace: false,
            imageName: '',
            uploadImageData: {},
            imageAvatar: '',
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if ((isEmpty(value)) || (value && value.length > 20) || (value && regex.test(value))) callback(new Error('Invalid screen name'))
                if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                else callback()
            },
        }
    },
    methods: {
        getMetaList: async function (type, fetchData) {
            try{
                if (fetchData === undefined) {
                    loader(this, true)
                    this.formData = await getDetails(type.toLowerCase(), this.$route.params.id)
                }
                this.contentData = cloneDeep(this.formData)
                this.setValues(this.contentData)
                loader(this, false)
            }
            catch (error) {
                loader(this, false)
                console.warn('A/P/P ERROR->', error)
            }
        },
        setValues (data) {
            this.url = data.url && data.url.length > 0 && data.url[0] || ''

            this.publisher = {
                name: data.name || '',
                registration_number: data.registration_number || '',
                website: '',
                screen_name: data.screen_name || ''
            }
            if (this.url.includes('https://')) {
                this.url = this.url.replace('https://', "")
                this.publisher.website = this.url.replace('https://', "")
            } else if (this.url.includes('http://')) {
                this.url = this.url.replace('http://', "")
                this.publisher.website = this.url.replace('http://', "")
            }
            this.des = {
                biography: data.biography || '',
                short_description: data.short_description || ''
            }

            this.publications = data.publications || []

            this.socialMedia = {
                social_media: data.social_media || [],
                _id: data._id
            }

            this.publisherImage = {
                avatar_image: data.avatar_image || '',
                imagePreview: data.imagePreview || null,
                _id: data._id
            }

            this.imagePreview = data.avatar_image || null
            this.address = {
                line1: (data.address && data.address.line1 && data.address.line1) || '',
                line2: (data.address && data.address.line2 && data.address.line2) || '',
                city: (data.address && data.address.city && data.address.city) || '',
                postal_code: (data.address && data.address.postal_code && data.address.postal_code) || '',
                country_code: (data.address && data.address.country_code && data.address.country_code) || '',
                country_name: (data.address && data.address.country_name && data.address.country_name) || '',
                contact_detail: {
                phone: (data.contact_detail && data.contact_detail.phone && data.contact_detail.phone) || '',
                fax: (data.contact_detail && data.contact_detail.fax && data.contact_detail.fax) || '',
                email: (data.contact_detail && data.contact_detail.email && data.contact_detail.email) || ''
                }
            }
            if (this.publisher.screen_name === '') {
                this.createMetaScreenName()
            }
        },
        updateFormData (type, data) {
            switch (type) {
                case 'NAME': 
                    this.formData.name ? this.formData.name = data.name : this.formData['name'] = data.name
                    this.formData.url ? this.formData.url = [data.url] : this.formData['url'] = [data.url]
                    this.formData.registration_number ? this.formData.registration_number = data.registration_number : this.formData['registration_number'] = data.registration_number 
                    this.formData.screen_name ? this.formData.screen_name = data.screen_name : this.formData['screen_name'] = data.screen_name
                break
                case 'DESCRIPTION':
                    this.formData.biography ? this.formData.biography = data.biography : this.formData['biography'] = data.biography
                    this.formData.short_description ? this.formData.short_description = data.short_description : this.formData['short_description'] = data.short_description
                    break
                case 'LOCATION':
                    this.formData.address ? this.formData.address = data.address : this.formData['address'] = data.address
                    this.formData.contact_detail ? this.formData.contact_detail = data.contact_detail : this.formData['contact_detail'] = data.contact_detail
                    break
                case 'PUBLICATION':
                    this.formData.publications ? this.formData.publications = cloneDeep(data) : this.formData['publications'] = cloneDeep(data)
                    break
                case 'IMAGE':
                    if (data !== undefined && data !== null) {
                        this.formData.avatar_image ? this.formData.avatar_image = data : this.formData['avatar_image'] = data
                    }
                    break
                case 'SOCIAL_MEDIA':
                    this.formData.social_media ? this.formData.social_media = data.social_media : this.formData['social_media'] = data.social_media
                    break
            }
            this.contentData = cloneDeep(this.formData)
            this.setValues(this.contentData)        
        },
        submitPublisherName (formName) {
            let publisher = cloneDeep(this.publisher)
            this.$refs[formName].validate(async(valid) => {
                if (!valid) return
                loader(this, true)
                if (this.publisher.screen_name !== '') {
                    let result = await this.validateMetaScreenName()
                    if (!result.isUnique) {
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, "Screen name is already taken")
                        return
                    }
                } 
                let body = publisher
                if (publisher.website !== '' &&  publisher.website !== null) body.url = `https://${publisher.website}`
                else body.url = ''
                delete body.website
                body.entity_ids = [this.$route.params.id]
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    this.updateFormData('NAME', body)
                    loader(this, false)
                }).catch(error => {
                    console.error(error)
                    loader(this, false)
                })
                
            })
        },
        EditPublisherDescription (formName) {
            let des = cloneDeep(this.des)
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                loader(this, true)
                let body = {
                    short_description: des.short_description,
                    biography: des.biography,
                    entity_ids: [this.$route.params.id]
                }
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    this.updateFormData('DESCRIPTION', des)
                    loader(this, false)
                }).catch(error => {
                    console.error(error)
                    loader(this, false)
                })  
            })
        },
        editPublisherLocation (location, contact_detail) { 
            loader(this, true)
            let address = cloneDeep(location)
            if (isEmpty(address.country_code)) delete address.country_code
            let body = {address, contact_detail, entity_ids: [this.$route.params.id]}        
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                message(this, constants.messageType.SUCCESS, "Update Successfully")
                this.updateFormData('LOCATION', {address: location, contact_detail})
                loader(this,false)
            }).catch(error => {
                loader(this,false)
                console.error(error)
            })
        },
        editSocialMediaLinks () {
        },
        setMetaToAdd (item) {
            this.metaToAdd = item
        },
        getUserRights: async function () {
            try {
                let body = {
                    type: this.category,
                    entity_id: this.$route.params.id
                }
                let users = await userRights(body)
                this.getUserData = users.user || {}
            }
            catch (error) {
                return error
            }
        },
        addUser:async function () {
            if(isEmpty(this.metaToAdd) || (this.metaToAdd._id === this.getUserData._id)) {
                this.metaToAdd = {}
                return
            }          
            try {
                loader(this, true)
                let body= {
                    user_admin_action : {
                        user_id: this.metaToAdd._id,
                        action: 'REPLACE_WITH'
                    },
                    entity_ids: [this.$route.params.id]        
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.getUserData = cloneDeep(this.metaToAdd)
                this.metaToAdd = {}
                loader(this, false)
            } catch (error) {
                this.metaToAdd = {}
                loader(this, false)
                return error
            }   
        },
        removeUser: async function () {
            if (isEmpty(this.getUserData)) return
            loader(this, true)
            let body= {
                user_admin_action : {
                    action: 'REMOVE'
                },
                entity_ids: [this.$route.params.id]
            }            
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.getUserData = {}
                loader(this, false)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
            }).catch(error => {
                loader(this, false)
                return error
            })
        },
        addPublication: async function () {
            let ids = this.publications.map(pub => pub._id)
            if (isEmpty(this.metaToAdd) || new Set(ids).has(this.metaToAdd._id)) return
            try {
                loader(this, true)
                let publications = cloneDeep(this.publications)
                publications.push(this.metaToAdd)
                let body = {
                    publication: {
                        action: 'ADD',
                        publication_id: this.metaToAdd._id
                    },
                    entity_ids: [this.$route.params.id]
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.publications = uniqBy(sortBy(publications, 'name'), '_id')
                this.updateFormData('PUBLICATION', this.publications)
                message(this,constants.messageType.SUCCESS, "Updated Successfully")
                this.metaToAdd = {}
                loader(this, false)
            } catch (error) {
                this.metaToAdd = {}
                loader(this, false)
                console.error(error) 
            } 
        },
        removePublication:async function (item) {
            try {
                loader(this, true)
                let publications = cloneDeep(this.publications)
                publications = publications.filter(pub => pub._id !== item._id)
                // let publicationIds = uniq(publications.map(pub => pub._id))
                let body = {
                    publication: {
                        publication_id: item._id,
                        action: 'REMOVE'
                    },
                    entity_ids: [this.$route.params.id]
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.publications = publications
                this.updateFormData('PUBLICATION', cloneDeep(publications))
                message(this,constants.messageType.SUCCESS,"Updated Successfully")
                loader(this, false)
            } catch (error) {
                loader(this, false)
                return error
            }   
        },
        validateField (rule, value, callback) {
            let pattern = /^[^a-zA-Z0-9]+$/;
            if (!isEmpty(value) && pattern.test(value)) callback(new Error('Invalid characters'))
            else callback() 
        },
        validateUrl (rule, value, callback) {
            if (!isEmpty(value) && value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
            if (!isEmpty(value) && !urlValidation('https://' + value)) callback(new Error('Incorrect url'))
            else callback()   
        },
        handleCommand (command) {
            switch (command) {
                case 'COPY':
                    copyElement(this.$route.params.id)
                break
                case 'SHOW_IN_IP':
                    this.$router.push({name: `publishers-overview`, params: this.$route.params.id})
                break
                case 'REPLACE': 
                    this.isReplace = true
                break
                case 'REMOVE': 
                    this.removeMeta()
                break
            }
        },
        disabledDescriptionForm () {
            if (isEmpty(this.formData.short_description) && isEmpty(this.formData.biography) && isEmpty(this.des.short_description) && isEmpty(this.des.biography)) return true
            if (this.formData.short_description !== this.des.short_description || this.formData.biography !== this.des.biography) return false
            return true
        },
        disabledNameForm () {
            if (this.formData.name !== this.publisher.name || this.formData.registration_number !== this.publisher.registration_number || (this.url !== this.publisher.website) || this.formData.screen_name !== this.publisher.screen_name) return false
            return true
        },
        replaceButtonAction (action, isTrue) {
            this.isReplace = false
            if (isTrue) {
                this.$store.dispatch('setCallPublishers', {label: 'Publishers', className: 'info'})
            }
        },
        handleAvatarSuccess () {
        },
        beforeAvatarUpload () {
        },
        uploadFile (file) {
            this.imageName = file.file.name
            this.uploadImage(this.category, file)
        },
         /*
        * uploadImage() uploads the image to the s3 server
        * */
       uploadImage: async function(module, file){
        loader(this, true);
        getImageUploadURL({imageName: this.imageName})
            .then((uploadUrls)=>{
                this.uploadImageData = uploadUrls;
                return this.createBlobObject(uploadUrls, file.file)
            }).then((image)=>{
                return uploadImage(image)
            }).then(()=>{
                let body = {
                    avatar_image: this.uploadImageData.fileKey,
                    entity_ids: [this.$route.params.id]
                }
                return bulkUpdate(module.toLowerCase(), body)
            }).then(()=>{
                loader(this, false);
                this.imageAvatar = this.uploadImageData.fileKey
                this.updateFormData('IMAGE', this.imageAvatar)
                message(this, constants.messageType.SUCCESS, 'Updated Successfully');
            }).catch((error)=> {
                loader(this, false);
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            });
    },
    /*
    * createBlobObject() creates and returns the binary image format to upload
    * */
    createBlobObject(uploadUrl, file){
        return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
         },
         removeMeta () {
             let body = {
                 entity_ids: [this.$route.params.id],
                 delete_from_ecosystem: true
             }
             bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.$store.dispatch('setCallPublishers', {label: 'Publishers', className: 'info'})
             }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
             })
         },
         removeImage () {
             loader (this, true)
             let body = {
                avatar_image: '',
                entity_ids: [this.$route.params.id]
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.updateFormData('IMAGE', '')
                loader(this, false)
            }).catch(error => {
                console.error(error)
                loader(this, false)
            })
         },

         /**
          * to validate the screen name
          */
         validateMetaScreenName: async function () {
            // body for api
            let body = {
                entity_type: this.category,
                screen_name: this.publisher.screen_name,
                entity_id: this.$route.params.id
            }
            // api call
            return await validateScreenName(body)
        },
        /**
         * to crete the screen name if screen name is not present
         */
        createMetaScreenName () {
            // body for api
            let body = {
                entity_type: this.category,
                name: this.publisher.name
            }
            // api call
            createScreenName(body).then(response => {
                // assign screen name
                this.$set(this.publisher, 'screen_name', response.response)
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        }
    }
}